import React, {Component} from "react";
import ProgressIndicator from "./ProgressIndicator";
import {Icon} from "@vitalsource/vstui";
import {Button} from "@vitalsource/vstui";
import conversionIcon from "../../../img/conversion.svg"


export interface ProductProgressIndicatorProps {
  children: React.ReactNode;
  actionType: string,
  status: string,
  progress: number
}

export interface ProductProgressIndicatorState {
  isHidden: boolean,
  isTransitioning: boolean
}

export default class ProductProgressIndicator extends Component<ProductProgressIndicatorProps, ProductProgressIndicatorState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isHidden: false,
      isTransitioning: false
    };

    this.setHiddenState = this.setHiddenState.bind(this);
    this.setIsTransitioningState = this.setIsTransitioningState.bind(this);
  }

  componentWillUpdate(nextProps: ProductProgressIndicatorProps, nextState: ProductProgressIndicatorState) {
    if ( this.state === nextState && this.props.actionType && !nextProps.actionType ) {
      this.triggerSuccessAnimation()
    }
  }

  setHiddenState(isHidden: boolean): void {
    this.setState({
      isHidden: isHidden
    });
  }

  setIsTransitioningState(isTransitioning: boolean): void {
    this.setState({
      isTransitioning: isTransitioning
    })
  }

  triggerSuccessAnimation(): void {
    this.setIsTransitioningState(true);
    setTimeout( () => {
      this.setHiddenState(true);
      this.setIsTransitioningState(false);
    }, 2500)
  }


  render() {
    return <ProgressIndicator hidden={this.state.isHidden || (!this.props.actionType && !this.state.isTransitioning)}
                              size="small"
                              progressInfo={{
                                status: this.props.status,
                                progress: this.props.progress
                              }}
                              icon={conversionIcon}
    >{this.props.children}</ProgressIndicator>;
  }
}
